import { ReactNode, createContext, useContext } from "react";
import UserStore from "./user";
import MenuStore from "./menu";
import CartStore from "./cart";
import OrderStore from "./order";

export class RootStore {
	user: UserStore;
	menu: MenuStore;
	cart: CartStore;
	order: OrderStore;
	constructor() {
		this.user = new UserStore(this);
		this.menu = new MenuStore(this);
		this.cart = new CartStore(this);
		this.order = new OrderStore(this);
	}
}

const rootStore = new RootStore();

const StoreContext = createContext(rootStore);

export const StoreProvider = ({ children }: { children: ReactNode }) => <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;

export const useStore = () => useContext(StoreContext);
